import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxToggleComponent } from './phx-toggle.component';
import { PhxTooltipModule } from './../tooltip/phx-tooltip.module';

@NgModule({
  imports: [
    CommonModule,
    PhxTooltipModule
  ],
  declarations: [PhxToggleComponent],
  exports: [PhxToggleComponent],
})
export class PhxToggleModule { }